<template>
    <Transition name="slide-down">
        <ul
            v-show="isActive"
            class="user-regions-list"
        >
            <li
                v-for="region in regions"
                :key="region.id"
                :class="[
                    'user-regions-list__item pointer',
                    {
                        active: activeRegion && activeRegion.id === region.id,
                    },
                ]"
                @click="selectRegion(region)"
            >
                {{ region.name }}
            </li>
        </ul>
    </Transition>
</template>

<script>
import {defineComponent} from 'vue';
import {REGIONS} from '@/core/constants/regions';

export default defineComponent({
    props: {
        isActive: {
            type: Boolean,
            required: true,
        },
        activeRegion: {
            type: Object,
            default: () => null,
        },
    },
    emits: ['select'],
    setup(_, context) {
        function selectRegion(region) {
            context.emit('select', region);
        }

        return {
            regions: REGIONS,
            selectRegion,
        };
    },
});
</script>

<style lang="scss">
    .user-regions-list {
        $p: &;

        position: absolute;
        top: 100%;
        right: 0;
        display: flex;
        align-items: flex-start;
        flex-direction: column;
        justify-content: flex-start;
        padding: 12px 16px;
        border-radius: $radius-6;
        background-color: var(--color-primary-70);
        box-shadow: $shadow4;

        &__item {
            display: inline-block;
            padding: 8px 0;
            font-size: 12px;
            white-space: nowrap;
            color: var(--color-text-45);
            transition: color 0.5s ease;

            &.active {
                color: var(--color-shape-15);
            }

            @include hover {
                color: var(--color-text-0);
            }
        }

        &--mobile {
            top: unset;
            right: 20px;
            bottom: 10%;
            left: 20px;

            #{$p}__item {
                font-size: 14px;
                line-height: 1.4;
            }
        }
    }
</style>
